<div *ngIf="!isSignInUser()">
    <!-- <div class="d-flex justify-content-center align-items-center vh-100">
        <div class="p-5">
            <div class="d-flex">
                <div class="padding-summary">Loading..</div>
                <div><img src="./../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
            </div>
        </div>
    </div> -->
    <app-root></app-root>
</div>

<div *ngIf="isSignInUser()">
    <div class="header-panel bg-white">
        <nav class="navbar navbar-expand-lg w-100 navbar-light bg-white">
            <div class="container-fluid d-flex justify-content-between align-items-center padding-left-15">
                <div class="navbar-brand d-flex align-items-center">
                    <fa-icon (click)="hideTab($event)" class="mr-1 cursor-pointer" [icon]="faBars"></fa-icon>
                    <a #specificDivBoxControl href="#">
                        <img class="logo" (click)="gotoDashboardhome()" src="../../../assets/Gyan-image.png" alt="Gyan Logo" />
                    </a>
                </div>

                <div
                    *ngIf="!isSignInUser()"
                    class="d-flex align-items-center cursor-pointer sign-in-link"
                    (click)="openLogInModal()"
                    [attr.id]="'signin-gyan'"
                    [attr.data-test]="'signin-gyan'"
                >
                    <img *ngIf="!isSignInUser()" class="SignIn-Icon align-items-center w-5" src="../../../assets/icon-sign-in.png" alt="Gyan SignIn" />
                    <span class="SignIn-text">{{ getSignInUser() }}</span>
                </div>
                <div *ngIf="isSignInUser()">
                    <button class="dropdown-toggle hem-text" id="userDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                        <!-- <img src="./assets/img/avatars/8.jpg" alt="User Avatar" class="user-avatar" /> -->
                        {{ getSignInUser() }}
                    </button>
                    <ul class="dropdown-menu option-box-shadow dropdown-menu-end comment-box-signin mr-2" aria-labelledby="userDropdown">
                        <div class="border-bottom-1px align-items-center comment-box-items-rapid-icon">
                            <a title="Admin" [routerLink]="'/admin'" class="dropdown-item hem-text" href="#">
                                <div class="dropdown-item-content" [attr.id]="'back-rapid'" [attr.data-test]="'back-rapid'" [ngClass]="{ 'highlight-admin-text': isAdminRoute }">
                                    <img
                                        src="../../../assets/Admin_Assets/icon_admin_settings.svg"
                                        alt="Back to Rapid"
                                        [ngClass]="{ 'highlight-admin': isAdminRoute }"
                                        class="dropdown-box rapid-icon"
                                    />
                                    Admin
                                </div>
                            </a>
                        </div>
                        <div class="border-bottom-1px align-items-center comment-box-items-reset-icon">
                            <a title="Reset Password" class="dropdown-item hem-text" (click)="resetPassword()" href="#">
                                <div class="dropdown-item-content" [attr.id]="'reset-password'" [attr.data-test]="'reset-password'">
                                    <img src="../../../assets/Admin_Assets/icon_reset_pwd.svg" alt="Reset Password" class="dropdown-box reset-icon" />
                                    Reset Password
                                </div>
                            </a>
                        </div>
                        <div class="comment-box-items-signout-icon">
                            <a title="Sign Out" class="dropdown-item hem-text" (click)="logout()" href="#">
                                <div class="dropdown-item-content" [attr.id]="'sign-out'" [attr.data-test]="'sign-out'">
                                    <img src="../../../assets/Admin_Assets/icon_signout.svg" alt="Sign Out" class="dropdown-box signout-icon" />
                                    Sign Out
                                </div>
                            </a>
                        </div>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
    <ng-container *ngIf="isVerifiedUser()">
        <!--For desktop view-->
        <div class="vh-80 d-none d-sm-none d-md-block d-lg-block" *ngIf="!isMobile">
            <div class="container-fluid">
                <div class="row d-flex article-css">
                    <div
                        class="col-lg-2 col-md-3 bg-white vh-95 p-0 rectangle"
                        [ngStyle]="style"
                        mwlResizable
                        [enableGhostResize]="true"
                        (resizeEnd)="onResizeEnd($event)"
                        *ngIf="!isHideTab"
                    >
                        <div class="resize-handle-right" mwlResizeHandle [resizeEdges]="{ right: true }"></div>
                        <div class="closeBtn d-none" title="drag" mwlResizeHandle [resizeEdges]="{ right: true }" (click)="resetSize()"></div>
                        <div class="overview-panel" *ngIf="isLoading">
                            <div class="mx-auto col-sm-9 text-center">
                                <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                                <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                            </div>
                        </div>

                        <div class="overview-panel top-left vh-80 mr-4p" *ngIf="!isLoading">
                            <div class="menu-content hem-text">
                                <!-- <div title="Select Sources" class="ps-2 d-flex align-items-center mt-3 menu-content-item">
                                    <img class="w-3 h-1 img-icon-sources disabled-cursor" src="../../../assets/Icons for LP/icon-select-source-disable.svg" />
                                    <span disabled="isSignInUser() && SelectSourcesPermission || !isSignInUser()" class="px-2 fs-6 menu-text-disabled disabled-cursor"
                                        >Select Sources</span
                                    >
                                </div> -->
                                <div
                                    title="User Management"
                                    class="ps-2 d-flex user-managment-link align-items-center menu-content-item mt-3"
                                    [ngClass]="isUsersdropdownopen ? 'user-managment-selected' : ''"
                                    [attr.id]="'user-managment'"
                                    [attr.data-test]="'user-managment'"
                                    (click)="displaySubManagements('user-management'); $event.stopPropagation()"
                                >
                                    <!-- (click)="toggleUsers()" -->
                                    <img class="w-3 h-1 img-icon-sources user-managment cursor-pointer" src="../../../assets/Admin_Assets/icon_user_management.svg" />
                                    <span class="px-2 menu-text fs-6 cursor-pointer">User Management</span>
                                    <span class="cursor-pointer icon-arrow-up" *ngIf="menuStates['user-management']"></span>
                                    <span class="icon-arrow-down cursor-pointer" *ngIf="!menuStates['user-management']"></span>
                                </div>

                                <!-- Dropdown for Users, updated class name to 'user-dropdown' -->
                                <div *ngIf="menuStates['user-management']" class="user-dropdown">
                                    <ul>
                                        <li (click)="clickClientMenu()" [ngClass]="isClientMenu ? 'sub-menu-selected' : ''" class="cursor-pointer">Clients</li>
                                        <li (click)="clickuserGroupMenu()" [ngClass]="isUserGroupMenu ? 'sub-menu-selected' : ''" class="cursor-pointer">User Groups</li>
                                        <li (click)="clickUserMenu()" [ngClass]="isUserMenu ? 'sub-menu-selected' : ''" class="cursor-pointer">Users</li>
                                        <!-- Add more users here -->
                                    </ul>
                                </div>

                                <div
                                    [ngClass]="isAcessdropdownopen ? 'acess-managment-selected' : ''"
                                    [attr.id]="'access-managment'"
                                    [attr.data-test]="'access-managment'"
                                    (click)="displaySubManagements('access-management'); $event.stopPropagation()"
                                    title="Access Management"
                                    class="ps-2 d-flex acess-managment-link align-items-center menu-content-item"
                                >
                                    <img class="w-3 h-1 img-icon-sources acess-managment cursor-pointer" src="../../../assets/Admin_Assets/icon_access_management.svg" />
                                    <span class="px-2 menu-text fs-6 cursor-pointer">Access Management</span>
                                    <span class="cursor-pointer icon-arrow-up" *ngIf="menuStates['access-management']"></span>
                                    <span class="icon-arrow-down cursor-pointer" *ngIf="!menuStates['access-management']"></span>
                                    <!-- <span class="icon-arrow-down-access" *ngIf="!menuStates['access-management']"></span> -->
                                </div>

                                <!-- Dropdown for Users, updated class name to 'user-dropdown' -->
                                <div *ngIf="menuStates['access-management']" class="user-dropdown">
                                    <ul>
                                        <li (click)="clickAccessMenu()" [ngClass]="isAccessMenu ? 'sub-menu-selected' : ''" class="cursor-pointer">Access</li>
                                        <!-- Add more users here -->
                                    </ul>
                                </div>
                                <div title="Gyan Settings" class="ps-2 d-flex align-items-center menu-content-item">
                                    <img class="w-3 h-1 img-icon-sources disabled-cursor" src="../../../assets/Admin_Assets/disabled/icon-gyan-settings-disable.svg" />
                                    <span disabled="isSignInUser() && SelectSourcesPermission || !isSignInUser()" class="px-2 fs-6 menu-text-disabled disabled-cursor"
                                        >Gyan Settings</span
                                    >
                                    <span class="icon-arrow-down-setting"></span>
                                </div>

                                <div
                                    title="Repository Settings"
                                    class="ps-2 d-flex repo-managment-link align-items-center menu-content-item"
                                    [ngClass]="isRepodropdownopen ? 'repo-managment-selected' : ''"
                                    [attr.id]="'repository-settings'"
                                    [attr.data-test]="'repository-settings'"
                                    (click)="displaySubManagements('repository-settings'); $event.stopPropagation()"
                                >
                                    <!-- (click)="toggleUsers()" -->
                                    <img class="w-3 h-1 img-icon-sources repo-managment cursor-pointer" src="../../../assets/Admin_Assets/icon_repository.svg" />
                                    <span class="px-2 menu-text fs-6 cursor-pointer">Repository Settings</span>
                                    <span class="cursor-pointer icon-arrow-up" *ngIf="menuStates['repository-settings']"></span>
                                    <span class="icon-arrow-down cursor-pointer" *ngIf="!menuStates['repository-settings']"></span>
                                </div>

                                <!-- Dropdown for Users, updated class name to 'user-dropdown' -->
                                <div *ngIf="menuStates['repository-settings']" class="user-dropdown">
                                    <ul>
                                        <li (click)="clickMKSMenu()" [ngClass]="ismks ? 'sub-menu-selected' : ''" class="cursor-pointer">My Content</li>
                                        <li (click)="clickGKSMenu()" [ngClass]="isgks ? 'sub-menu-selected' : ''" class="cursor-pointer">Knowledge Store</li>
                                        <!-- <li (click)="clickGKSMenu()" [ngClass]="isgks ? 'sub-menu-selected' : ''" class="cursor-pointer">Gyan Knowledge Store</li> -->
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="p-0 vh-90 bg-white overview-panel-menu-icon" *ngIf="isHideTab">
                        <div class="overview-panel">
                            <div class="menu-content">
                                <div
                                    (click)="toggleUsers()"
                                    title="User Management"
                                    [ngClass]="isUsersdropdownopen ? 'user-managment-selected' : ''"
                                    class="ps-2 d-flex align-items-center mt-3 menu-content-item cursor-pointer"
                                >
                                    <img class="w-3 h-1 u-search" src="../../../assets/Admin_Assets/icon_user_management.svg" />
                                </div>
                                <div
                                    (click)="toggleAcess()"
                                    [ngClass]="isAcessdropdownopen ? 'acess-managment-selected' : ''"
                                    title="Access Management"
                                    class="ps-2 d-flex align-items-center menu-content-item"
                                >
                                    <img class="cursor-pointer w-3 h-1 img-icon-sources a-search" src="../../../assets/Admin_Assets/icon-access-management.svg" />
                                </div>
                                <div title="Gyan Settings" class="ps-2 d-flex align-items-center menu-content-item">
                                    <img class="disabled-cursor w-3 h-1 img-icon-sources" src="../../../assets/Admin_Assets/disabled/icon-gyan-settings-disable.svg" />
                                </div>
                                <div
                                    (click)="toggleRepo()"
                                    [ngClass]="isRepodropdownopen ? 'repo-managment-selected' : ''"
                                    title="Repository Settings"
                                    class="ps-2 d-flex align-items-center menu-content-item"
                                >
                                    <img class="cursor-pointer w-3 h-1 img-icon-sources r-search" src="../../../assets/Admin_Assets/icon-repo-settings.svg" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class=""
                        [ngClass]="{
                            'overview-panel-menu-click p-0': isHideTab,
                            'col-lg-10 col-md-9 p-0': !isHideTab,
                            'resize-main-panel': resizeEndFlag,
                            'position-mobile': isMobile,
                        }"
                    >
                        <!-- <div *ngIf="componentName === 'client'">
                        HELLO SHOW WHEN CLIENT IS CLICKED
                        <app-clients></app-clients>
                    </div> -->
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>

        <!--For Mobile view-->
        <div class="vh-92 d-sm-block d-md-none" *ngIf="isMobile">
            <div class="container-fluid h-100">
                <div class="row d-flex article-css h-100">
                    <div class="col-lg-2 col-md-3 p-0" #specificDivBox *ngIf="isHideTab">
                        <div class="overview-panel bg-white custom-mobile-menu">
                            <div class="menu-content vh-80 overflow-y">
                                <div
                                    title="User Management"
                                    class="ps-2 d-flex user-managment-link align-items-center menu-content-item mt-3"
                                    [ngClass]="isUsersdropdownopen ? 'user-managment-selected' : ''"
                                    [attr.id]="'user-managment'"
                                    [attr.data-test]="'user-managment'"
                                    (click)="displaySubManagements('user-managment'); $event.stopPropagation()"
                                >
                                    <!-- (click)="toggleUsers()" -->
                                    <img class="w-3 h-1 img-icon-sources user-managment cursor-pointer" src="../../../assets/Admin_Assets/icon_user_management.svg" />
                                    <span class="px-2 menu-text fs-6 cursor-pointer">User Management</span>
                                    <span class="cursor-pointer icon-arrow-up" *ngIf="menuStates['user-management']"></span>
                                    <span class="icon-arrow-down cursor-pointer" *ngIf="!menuStates['user-management']"></span>
                                </div>

                                <!-- Dropdown for Users, updated class name to 'user-dropdown' -->
                                <div *ngIf="menuStates['user-management']" class="user-dropdown">
                                    <ul>
                                        <li (click)="clickClientMenu()" [ngClass]="isClientMenu ? 'sub-menu-selected' : ''" class="cursor-pointer">Clients</li>
                                        <li (click)="clickuserGroupMenu()" [ngClass]="isUserGroupMenu ? 'sub-menu-selected' : ''" class="cursor-pointer">User Group</li>
                                        <li (click)="clickUserMenu()" [ngClass]="isUserMenu ? 'sub-menu-selected' : ''" class="cursor-pointer">Users</li>
                                        <!-- Add more users here -->
                                    </ul>
                                </div>
                                <!-- For Mobile by Sagar -->
                                <div
                                    title="Access Managemen"
                                    class="ps-2 d-flex acess-managment-link align-items-center menu-content-item"
                                    [ngClass]="isAcessdropdownopen ? 'acess-managment-selected' : ''"
                                    [attr.id]="'acess-managment'"
                                    [attr.data-test]="'acess-managment'"
                                    (click)="displaySubManagements('acess-managment'); $event.stopPropagation()"
                                >
                                    <!-- (click)="toggleUsers()" -->
                                    <img class="w-3 h-1 img-icon-sources acess-managment cursor-pointer" src="../../../assets/Admin_Assets/icon_access_management.svg" />
                                    <span class="px-2 menu-text fs-6 cursor-pointer">Access Management</span>
                                    <span class="cursor-pointer icon-arrow-up" *ngIf="menuStates['acess-management']"></span>
                                    <span class="icon-arrow-down cursor-pointer" *ngIf="!menuStates['acess-management']"></span>
                                </div>

                                <!-- Dropdown for Users, updated class name to 'user-dropdown' -->
                                <div *ngIf="menuStates['acess-management']" class="user-dropdown">
                                    <ul>
                                        <li (click)="clickAccessMenu()" [ngClass]="isClientMenu ? 'sub-menu-selected' : ''" class="cursor-pointer">Access Managment</li>
                                        <!-- Add more users here -->
                                    </ul>
                                </div>

                                <!-- For Sagar -->

                                <div title="Access Management" class="ps-2 d-flex align-items-center menu-content-item">
                                    <img class="w-3 h-1 img-icon-sources disabled-cursor" src="../../../assets/Admin_Assets/disabled/icon-acces-management-disable.svg" />
                                    <span disabled="isSignInUser() && SelectSourcesPermission || !isSignInUser()" class="px-2 fs-6 menu-text-disabled disabled-cursor"
                                        >Access Management</span
                                    >
                                    <span class="icon-arrow-down-access"></span>
                                </div>
                                <div title="Gyan Settings" class="ps-2 d-flex align-items-center menu-content-item">
                                    <img class="w-3 h-1 img-icon-sources disabled-cursor" src="../../../assets/Admin_Assets/disabled/icon-gyan-settings-disable.svg" />
                                    <span disabled="isSignInUser() && SelectSourcesPermission || !isSignInUser()" class="px-2 fs-6 menu-text-disabled disabled-cursor"
                                        >Gyan Settings</span
                                    >
                                    <span class="icon-arrow-down-setting"></span>
                                </div>
                                <div title="Repository Settings" class="ps-2 d-flex align-items-center menu-content-item">
                                    <img class="w-3 h-1 img-icon-sources disabled-cursor" src="../../../assets/Admin_Assets/disabled/icon-repository-settings-disable.svg" />
                                    <span disabled="isSignInUser() && SelectSourcesPermission || !isSignInUser()" class="px-2 fs-6 menu-text-disabled disabled-cursor"
                                        >Repository Settings</span
                                    >
                                    <span class="icon-arrow-down-repo"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 p-0 h-100">
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!isVerifiedUser()">
        <!--For desktop view-->
        <div class="vh-80 d-none d-sm-none d-md-block d-lg-block">
            <div class="container-fluid">
                <div class="row d-flex article-css">
                    <div class="col-lg-12 col-md-12">
                        <main class="d-flex justify-content-center align-items-center vh-90">
                            <div class="container col-lg-6 col-md-6 bg-white d-flex justify-content-center">
                                <!-- <div class="row d-flex justify-content-center"> -->
                                <div class="col-lg-12 col-md-12 p-0">
                                    <div class="card-group p-0">
                                        <div class="card px-5 my-2 mx-1 border-0">
                                            <div class="card-body p-3 my-4">
                                                <div class="d-flex justify-content-center text-center mb-2">
                                                    <h1 class="error-color regular-heading-text fw-semi-bold">Verification failed!</h1>
                                                </div>
                                                <div class="d-flex justify-content-center text-center mb-3">
                                                    <h5 class="mb-0">Please check your email to verify your account and get started.</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- </div> -->
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </div>
        <!--For Mobile view-->
        <div class="vh-80 d-sm-block d-md-none">
            <div class="container-fluid">
                <div class="row d-flex article-css">
                    <div class="col-lg-12 py-2 pr-2">
                        <main class="main d-flex align-items-center">
                            <div class="container d-flex justify-content-center">
                                <div class="row d-flex justify-content-center">
                                    <div class="col-md-12 px-0">
                                        <div class="card-group px-5">
                                            <div class="card px-5 my-2 mx-1">
                                                <div class="card-body p-3 my-4">
                                                    <div class="d-flex justify-content-center text-center mb-2">
                                                        <h1 class="error-color regular-heading-text fw-semi-bold">Verification failed!</h1>
                                                    </div>
                                                    <div class="d-flex justify-content-center text-center mb-3">
                                                        <h5 class="mb-0">Please check your email to verify your account and get started.</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
<app-getpro></app-getpro>
<app-login></app-login>
